import React, { Component } from 'react';
import { useNavigate } from 'react-router-dom';
import { FacebookIcon, TwitterIcon, InstagramIcon, LinkedinIcon, GithubIcon } from 'lucide-react';
export const Footer = () => {
  const navigate = useNavigate();
  const handleNavigation = (path: string) => {
    navigate(path);
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return <footer className="bg-gray-50 dark:bg-[#0B2C2A] pt-16 pb-8" data-id="element-1115">
      <div className="container mx-auto px-4 md:px-6" data-id="element-1116">
        {/* Main footer row — 4 columns */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-12" data-id="element-1117">
          {/* Marketplace links */}
          <div data-id="element-1118">
            <h3 className="font-semibold text-gray-900 dark:text-[#F8FAF9] mb-4" data-id="element-1119">
              Marketplace
            </h3>
            <ul className="space-y-3" data-id="element-1120">
              <li data-id="element-1121">
                <button onClick={() => handleNavigation('/browse?category=Website Templates')} className="text-gray-600 dark:text-[#B0C1BD] hover:text-[#2DB489] dark:hover:text-[#4ED1A0] transition-colors" data-id="element-1122">
                  Templates
                </button>
              </li>
              <li data-id="element-1123">
                <button onClick={() => handleNavigation('/browse?category=UI Kits')} className="text-gray-600 dark:text-[#B0C1BD] hover:text-[#2DB489] dark:hover:text-[#4ED1A0] transition-colors" data-id="element-1124">
                  UI Kits
                </button>
              </li>
              <li data-id="element-1125">
                <button onClick={() => handleNavigation('/browse?category=Icon Packs')} className="text-gray-600 dark:text-[#B0C1BD] hover:text-[#2DB489] dark:hover:text-[#4ED1A0] transition-colors" data-id="element-1126">
                  Icons
                </button>
              </li>
              <li data-id="element-1127">
                <button onClick={() => handleNavigation('/browse?category=' + encodeURIComponent('3D Assets & Mockups'))} className="text-gray-600 dark:text-[#B0C1BD] hover:text-[#2DB489] dark:hover:text-[#4ED1A0] transition-colors" data-id="element-1128">
                  Mockups
                </button>
              </li>
              <li data-id="element-1129">
                <button onClick={() => handleNavigation('/browse')} className="text-gray-600 dark:text-[#B0C1BD] hover:text-[#2DB489] dark:hover:text-[#4ED1A0] transition-colors" data-id="element-1130">
                  Illustrations
                </button>
              </li>
            </ul>
          </div>
          {/* Resources links */}
          <div data-id="element-1131">
            <h3 className="font-semibold text-gray-900 dark:text-[#F8FAF9] mb-4" data-id="element-1132">
              Resources
            </h3>
            <ul className="space-y-3" data-id="element-1133">
              <li data-id="element-1134">
                <button onClick={() => handleNavigation('/blog')} className="text-gray-600 dark:text-[#B0C1BD] hover:text-[#2DB489] dark:hover:text-[#4ED1A0] transition-colors" data-id="element-1135">
                  Blog
                </button>
              </li>
              <li data-id="element-1136">
                <button onClick={() => handleNavigation('/tutorials')} className="text-gray-600 dark:text-[#B0C1BD] hover:text-[#2DB489] dark:hover:text-[#4ED1A0] transition-colors" data-id="element-1137">
                  Tutorials
                </button>
              </li>
              <li data-id="element-1138">
                <button onClick={() => handleNavigation('/docs')} className="text-gray-600 dark:text-[#B0C1BD] hover:text-[#2DB489] dark:hover:text-[#4ED1A0] transition-colors" data-id="element-1139">
                  Documentation
                </button>
              </li>
              <li data-id="element-1140">
                <button onClick={() => handleNavigation('/community')} className="text-gray-600 dark:text-[#B0C1BD] hover:text-[#2DB489] dark:hover:text-[#4ED1A0] transition-colors" data-id="element-1141">
                  Community
                </button>
              </li>
            </ul>
          </div>
          {/* For Sellers */}
          <div data-id="element-1142">
            <h3 className="font-semibold text-gray-900 dark:text-[#F8FAF9] mb-4" data-id="element-1143">
              For Sellers
            </h3>
            <ul className="space-y-3" data-id="element-1144">
              <li data-id="element-1145">
                <button onClick={() => handleNavigation('/sell-with-us')} className="text-gray-600 dark:text-[#B0C1BD] hover:text-[#2DB489] dark:hover:text-[#4ED1A0] transition-colors" data-id="element-1146">
                  Start Selling
                </button>
              </li>
              <li data-id="element-1147">
                <button onClick={() => handleNavigation('/affiliate-program')} className="text-gray-600 dark:text-[#B0C1BD] hover:text-[#2DB489] dark:hover:text-[#4ED1A0] transition-colors" data-id="element-1148">
                  Affiliate Dashboard
                </button>
              </li>
              <li data-id="element-1149">
                <button onClick={() => handleNavigation('/resources/listing-checklist')} className="text-gray-600 dark:text-[#B0C1BD] hover:text-[#2DB489] dark:hover:text-[#4ED1A0] transition-colors" data-id="element-1150">
                  Upload Guidelines
                </button>
              </li>
              <li data-id="element-1151">
                <button onClick={() => handleNavigation('/resources/pricing')} className="text-gray-600 dark:text-[#B0C1BD] hover:text-[#2DB489] dark:hover:text-[#4ED1A0] transition-colors" data-id="element-1152">
                  Pricing Guide
                </button>
              </li>
              <li data-id="element-1153">
                <button onClick={() => handleNavigation('/help-center')} className="text-gray-600 dark:text-[#B0C1BD] hover:text-[#2DB489] dark:hover:text-[#4ED1A0] transition-colors" data-id="element-1154">
                  Help Center
                </button>
              </li>
            </ul>
          </div>
          {/* Company links */}
          <div data-id="element-1155">
            <h3 className="font-semibold text-gray-900 dark:text-[#F8FAF9] mb-4" data-id="element-1156">
              Company
            </h3>
            <ul className="space-y-3" data-id="element-1157">
              <li data-id="element-1158">
                <button onClick={() => handleNavigation('/about')} className="text-gray-600 dark:text-[#B0C1BD] hover:text-[#2DB489] dark:hover:text-[#4ED1A0] transition-colors" data-id="element-1159">
                  About Us
                </button>
              </li>
              <li data-id="element-1160">
                <button onClick={() => handleNavigation('/careers')} className="text-gray-600 dark:text-[#B0C1BD] hover:text-[#2DB489] dark:hover:text-[#4ED1A0] transition-colors" data-id="element-1161">
                  Careers
                </button>
              </li>
              <li data-id="element-1162">
                <button onClick={() => handleNavigation('/contact')} className="text-gray-600 dark:text-[#B0C1BD] hover:text-[#2DB489] dark:hover:text-[#4ED1A0] transition-colors" data-id="element-1163">
                  Contact
                </button>
              </li>
              <li data-id="element-1164">
                <button onClick={() => handleNavigation('/privacy-policy')} className="text-gray-600 dark:text-[#B0C1BD] hover:text-[#2DB489] dark:hover:text-[#4ED1A0] transition-colors" data-id="element-1165">
                  Privacy Policy
                </button>
              </li>
              <li data-id="element-1166">
                <button onClick={() => handleNavigation('/terms')} className="text-gray-600 dark:text-[#B0C1BD] hover:text-[#2DB489] dark:hover:text-[#4ED1A0] transition-colors" data-id="element-1167">
                  Terms of Service
                </button>
              </li>
            </ul>
          </div>
        </div>
        {/* Social icons — centered */}
        <div className="flex justify-center space-x-5 mb-8" data-id="element-1168">
          <a href="#" className="text-gray-400 dark:text-[#7A8F8A] hover:text-[#2DB489] dark:hover:text-[#4ED1A0] transition-colors" data-id="element-1169">
            <FacebookIcon className="h-5 w-5" data-id="element-1170" />
          </a>
          <a href="#" className="text-gray-400 dark:text-[#7A8F8A] hover:text-[#2DB489] dark:hover:text-[#4ED1A0] transition-colors" data-id="element-1171">
            <TwitterIcon className="h-5 w-5" data-id="element-1172" />
          </a>
          <a href="#" className="text-gray-400 dark:text-[#7A8F8A] hover:text-[#2DB489] dark:hover:text-[#4ED1A0] transition-colors" data-id="element-1173">
            <InstagramIcon className="h-5 w-5" data-id="element-1174" />
          </a>
          <a href="#" className="text-gray-400 dark:text-[#7A8F8A] hover:text-[#2DB489] dark:hover:text-[#4ED1A0] transition-colors" data-id="element-1175">
            <LinkedinIcon className="h-5 w-5" data-id="element-1176" />
          </a>
          <a href="#" className="text-gray-400 dark:text-[#7A8F8A] hover:text-[#2DB489] dark:hover:text-[#4ED1A0] transition-colors" data-id="element-1177">
            <GithubIcon className="h-5 w-5" data-id="element-1178" />
          </a>
        </div>
        {/* Bottom bar */}
        <div className="pt-8 border-t border-gray-200 dark:border-[#1A3330] flex flex-col md:flex-row justify-between items-center" data-id="element-1179">
          <p className="text-gray-500 dark:text-[#7A8F8A] text-sm mb-4 md:mb-0" data-id="element-1180">
            © {new Date().getFullYear()} DGStack. All rights reserved.
          </p>
          <div className="flex items-center space-x-6" data-id="element-1181">
            <button onClick={() => handleNavigation('/privacy-policy')} className="text-gray-500 dark:text-[#7A8F8A] hover:text-[#2DB489] dark:hover:text-[#4ED1A0] text-sm transition-colors" data-id="element-1182">
              Privacy Policy
            </button>
            <button onClick={() => handleNavigation('/terms')} className="text-gray-500 dark:text-[#7A8F8A] hover:text-[#2DB489] dark:hover:text-[#4ED1A0] text-sm transition-colors" data-id="element-1183">
              Terms of Service
            </button>
            <button onClick={() => handleNavigation('/privacy-policy#cookies')} className="text-gray-500 dark:text-[#7A8F8A] hover:text-[#2DB489] dark:hover:text-[#4ED1A0] text-sm transition-colors" data-id="element-1184">
              Cookie Policy
            </button>
          </div>
        </div>
      </div>
    </footer>;
};